import { render, staticRenderFns } from "./InsuranceFixedFooter.vue?vue&type=template&id=35dd33ca&scoped=true&"
import script from "./InsuranceFixedFooter.vue?vue&type=script&lang=js&"
export * from "./InsuranceFixedFooter.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceFixedFooter.vue?vue&type=style&index=0&id=35dd33ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd33ca",
  null
  
)

export default component.exports